export default {
    attribute: {
        loop: true, autoplay: true, muted: true, source: 1, fileUrl: '', isControls: false,
        url: 'https://video.pearvideo.com/mp4/third/20200212/cont-1651180-11487675-112807-hd.mp4'
    },
    interaction: { intType: 'none' }
}